export default {"src":"/pro/_next/static/media/weth.62c152dc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};